import JWTDECODE from "jwt-decode";
const [
  ACCESS_TOKEN,
  USER,
  WALLET,
  WALLET_METADATA,
  SHOP_METADATA,
  CREATED_BY,
  ADDITIONAL_SERVICE,
  ORDER_CART,
  ORDER_ID,
  SENDER,
  BATCH_NO,
] = [
  "access_token",
  "user",
  "wallet",
  "wallet_metadata",
  "shop_metadata",
  "created_by",
  "additional_service",
  "order_cart",
  "order_id",
  "sender",
  "batch_no",
];
export default {
  get(itemName) {
    let res = {};
    const check = localStorage.getItem(itemName);
    try {
      res[itemName] = check ? JSON.parse(check) : null;
    } catch (err) {
      console.log(`LocalStorageManagement:: ${err}`);
      res[itemName] = null;
    }
    return res;
  },
  _jwtDecode(token) {
    return JWTDECODE(token);
  },
  setLogin(data) {
    try {
      const token = data.token;
      const wallet = data.wallet;
      const wallet_metadata = data.wallet_metadata;
      const additionalService = data.additional_service;

      const resAccessToken = this.accessToken().set(token);
      const resUser = this.user().set(token);
      const resWallet = this.wallet().set(wallet);
      const resWalletMetadata = this.walletMetadata().set(wallet_metadata);
      const resAdditionalService =
        this.additionalService().set(additionalService);

      return {
        access_token: resAccessToken,
        user: resUser,
        wallet: resWallet,
        walletMetadata: resWalletMetadata,
        additionalService: resAdditionalService,
      };
    } catch (err) {
      return err;
    }
  },
  batchNo() {
    return {
      set: (batch_no) => {
        localStorage.setItem(BATCH_NO, JSON.stringify(batch_no));
        return batch_no;
      },
      get: () => this.get(BATCH_NO),
      remove: () => {
        localStorage.removeItem(BATCH_NO);
      },
    };
  },
  orderCart() {
    return {
      set: (order) => {
        localStorage.setItem(ORDER_CART, JSON.stringify(order));
        return order;
      },
      get: () => this.get(ORDER_CART),
      remove: () => {
        localStorage.removeItem(ORDER_CART);
      },
    };
  },
  sender() {
    return {
      set: (data) => {
        localStorage.setItem(SENDER, JSON.stringify(data));
        return data;
      },
      get: () => this.get(SENDER),
      remove: () => {
        localStorage.removeItem(SENDER);
      },
    };
  },
  orderId() {
    return {
      set: (orderId) => {
        localStorage.setItem(ORDER_ID, orderId);
        return orderId;
      },
      get: () => this.get(ORDER_ID),
      remove: () => {
        localStorage.removeItem(ORDER_ID);
      },
    };
  },
  accessToken() {
    return {
      set: (token) => {
        localStorage.setItem(ACCESS_TOKEN, token);
        return token;
      },
      get: () => this.get(ACCESS_TOKEN),
    };
  },
  user() {
    return {
      set: (token) => {
        const user = this._jwtDecode(token);
        localStorage.setItem(USER, JSON.stringify(user));
        return user;
      },
      get: () => this.get(USER),
    };
  },
  wallet() {
    return {
      set: (wallet) => {
        localStorage.setItem(WALLET, JSON.stringify(wallet));
        return wallet;
      },
      get: () => this.get(WALLET),
    };
  },
  walletMetadata() {
    return {
      set: (wallet_metadata) => {
        localStorage.setItem(WALLET_METADATA, JSON.stringify(wallet_metadata));
        return wallet_metadata;
      },
      get: () => this.get(WALLET_METADATA),
    };
  },
  shopMetadata() {
    return {
      set: (shop_metadata) => {
        localStorage.setItem(SHOP_METADATA, JSON.stringify(shop_metadata));
        return shop_metadata;
      },
      get: () => this.get(SHOP_METADATA),
    };
  },
  createdBy() {
    return {
      set: (createdBy) => {
        localStorage.setItem(CREATED_BY, createdBy);
        return createdBy;
      },
      get: () => this.get(CREATED_BY),
    };
  },
  additionalService() {
    return {
      set: (services) => {
        localStorage.setItem(ADDITIONAL_SERVICE, JSON.stringify(services));
        return services;
      },
      get: () => this.get(ADDITIONAL_SERVICE),
    };
  },
  dimension() {
    return {
      set: (key, dimension) => {
        localStorage.setItem(key, JSON.stringify(dimension));
        return dimension;
      },
      get: (key) => this.get(key),
      remove: (key) => {
        localStorage.removeItem(key);
      },
    };
  },
};
